import React from 'react';
import '../../assets/styles/LandingPath.css';

import LandingPathHCLTechLogo from '../../assets/images/Grow.svg';

import LandingPathPearsonLogo from '../../assets/images/Build.svg';

import LandingPathContentsBorderImage from '../../assets/images/ARISE WEBSITE_microsite-18.png';
import bulb from '../../assets/images/Vector.svg'
import RightArrow from '../../assets/images/svg/Right arrow.svg';


const LandingInternship = ({onEnrollClick}) => {


      const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // smooth scroll
    });
  };
    return (
        <section className='landing-path-section'>
            <div className='landing-path-container pt-5'>
                <div className='landing-path-title-box text-center'>
                    <h2 className='landing-path-title'>INTERNSHIPS</h2>
                    <p className='justify-content-center align-items-center text-center'>Beyond the program, your entrepreneurial journey continues with invaluable, hands-on experience. 
                        <br/>Through our extensive network, you can secure exclusive internship opportunities to turn your knowledge into real-world impact</p>
                    <div className='landing-path-border-image-box'>
                        <img 
                            src={LandingPathContentsBorderImage} 
                            alt='Contents Border' 
                            className='landing-path-border-image' 
                        />
                    </div>
                </div>

                <div className='landing-path-carousel d-flex justify-content-center flex-wrap mt-4'>
                    <div className='landing-path-card'>
                        <img src={bulb} alt='HCLTech Logo' className='landing-path-logo' />
                        <h3>Test Your Idea</h3>
                        <p>Apply your entrepreneurial skills to solve business challenges at leading companies.</p>
                    </div>

                    <div className='landing-path-card'>
                        <img src={LandingPathHCLTechLogo} alt='Career Shaper Logo' className='landing-path-logo' />
                        <h3>Grow Your Network</h3>
                        <p>Get direct mentorship from the founders and leaders you admire.</p>
                    </div>

                    <div className='landing-path-card'>
                        {/* <img src={LandingPathPearsonLogo} alt='Pearson Logo' className='landing-path-logo' /> */}
                         <img src={LandingPathPearsonLogo} alt='Pearson Logo' className='landing-path-logo' />
                        <h3>Build Foundational Skills</h3>
                        <p>Master the core skills for building a company.</p>
                    </div>

                  
                </div>

              <div className="landing-register-btn-wrapper">
  {/* <div className="landing-cta-button" onClick={onEnrollClick}> */}
  <div
    className="landing-cta-button"
    onClick={() => {
      if (onEnrollClick) onEnrollClick(); // optional callback
      window.open("https://ariseforyou.com/register", "_blank"); // opens in new tab
    }}
  >
    <p className="mb-0 txt-white font-regular-four txt-size">Register Now</p>
    <img src={RightArrow} alt="Right Arrow" className="landing-cta-button-arrow" />
  </div>
</div>
            </div>
        </section>
    );
};

export default LandingInternship;
